import { cn } from '@/lib/utils';

/** Chip lọc danh sách (thu hẹp một danh sách). Đổi giữa các góc nhìn thì dùng Tabs, không dùng chip. */
export default function FilterChips<T extends string>({ value, onChange, options, label = 'Lọc' }: {
  value: T; onChange: (v: T) => void; options: Array<{ id: T; label: string; count?: number }>; label?: string;
}) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={label}>
      {options.map(o => (
        <button key={o.id} onClick={() => onChange(o.id)} aria-pressed={value === o.id}
          className={cn('min-h-9 rounded-full border px-3.5 text-sm font-medium transition-colors', value === o.id ? 'border-primary bg-accent text-accent-foreground' : 'border-border text-muted-foreground hover:bg-secondary')}>
          {o.label}{o.count !== undefined && <span className="num ml-1 font-normal opacity-70">{o.count}</span>}
        </button>
      ))}
    </div>
  );
}
